var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1587 16.11C19.8674 16.3924 19.7335 16.8007 19.7999 17.2013L20.8 22.7362C20.8844 23.2054 20.6864 23.6801 20.2937 23.9513C19.909 24.2325 19.3971 24.2663 18.9775 24.0413L13.9949 21.4425C13.8216 21.3503 13.6292 21.3008 13.4324 21.2951H13.1275C13.0217 21.3109 12.9182 21.3446 12.8237 21.3964L7.83999 24.0075C7.59361 24.1313 7.31461 24.1751 7.04124 24.1313C6.37524 24.0053 5.93086 23.3708 6.03999 22.7014L7.04124 17.1664C7.10761 16.7625 6.97374 16.3519 6.68236 16.065L2.61999 12.1275C2.28024 11.7979 2.16211 11.3029 2.31736 10.8562C2.46811 10.4107 2.85286 10.0856 3.31749 10.0125L8.90874 9.20138C9.33399 9.1575 9.70749 8.89875 9.89874 8.51625L12.3625 3.465C12.421 3.3525 12.4964 3.249 12.5875 3.16125L12.6887 3.0825C12.7416 3.024 12.8024 2.97562 12.8699 2.93625L12.9925 2.89125L13.1837 2.8125H13.6574C14.0804 2.85638 14.4527 3.1095 14.6474 3.4875L17.1437 8.51625C17.3237 8.88413 17.6736 9.1395 18.0775 9.20138L23.6687 10.0125C24.1412 10.08 24.5361 10.4062 24.6925 10.8562C24.8399 11.3074 24.7127 11.8024 24.3662 12.1275L20.1587 16.11Z",
    fill: "#FFD130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.66a1718522656c8ad0bd0a8dd0e0e4f2.svg";
export { ForwardRef as ReactComponent };